module.exports = __webpack_public_path__ + "img/parking-space-occupied.7e561a4f.svg";